import getFileDownloadUrl from '../utils/getFileDownloadUrl';
import { BaseFileInformation } from 'owa-group-files-hub-store';

export default function downloadRecentFileAction(fileInformation: BaseFileInformation): void {
    const downloadUrl = getFileDownloadUrl(fileInformation);
    window.open(downloadUrl, '_blank');
}
